/**
 * 
 * @param {number} value 
 * @param {number} min 
 * @param {number} max 
 * @param {number} newMin 
 * @param {number} newMax 
 * @returns {number}
 */
export default function interpolate(value, min, max, newMin, newMax) {
    let newValue = ( (value-min) / (max-min) ) * (newMax-newMin) + newMin;
    return newValue;
}
